import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  donutCriteria: null,
  rainbowCriteria: null,
  bookingChangeCriteria: null,
  btmSubmitData: []
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/booking/store/index.js